module.exports = __webpack_public_path__ + "static/media/kumiko.dbde0873.png";